import { inject } from '@angular/core';
import type {
  ActivatedRouteSnapshot,
  CanActivateFn,
  RouterStateSnapshot,
} from '@angular/router';
import { NotFound } from '@freelancer/404';
import { of } from 'rxjs';
import { TRANSPORT_ROUTES } from '../freightlancer-transport-routes-page/freightlancer-transport-routes-page.model';

/**
 * This guard is used to check transport routes pages and if the url param
 * is not a valid route, we redirect the user to the not-found page
 */
export const FreightlancerTransportRouteDetailsPageGuard = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
): ReturnType<CanActivateFn> => {
  const notFound = inject(NotFound);

  if (
    Object.values(
      TRANSPORT_ROUTES.map(transportRoute => transportRoute.link),
    ).includes(route.params.route)
  ) {
    return of(true);
  }

  return notFound.render();
};
